import { Reducer } from '@reduxjs/toolkit'

// import { RootState } from '../../App/store'
import { IEstablishment } from '../../Establishment/interface/IEstablishment'
import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
  SET_TIME_SCHEDULES,
  SET_TIME_SCHEDULES_SUCCESS,
  SET_TIME_SCHEDULES_FAILURE,
  TActionTypes,
} from '../actionTypes'
import { IUser } from '../DataStore/IUser'

import { IUserState } from './IUserState'

export const initialState: IUserState = {
  list: [],
  loading: false,
  saving: false,
  currentUser: undefined,
  currentUserLoading: false,
  error: null,
}

export const userReducer: Reducer<IUserState, TActionTypes> = (
  state = initialState,
  action,
) => {
  let userIndex

  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        loading: true,
      }
    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.users,
      }
    case GET_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }
    case GET_CURRENT_USER:
      return {
        ...state,
        currentUserLoading: true,
      }
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload.currentUser,
        currentUserLoading: false,
      }
    case GET_CURRENT_USER_FAILURE:
      return {
        ...state,
        currentUserLoading: false,
        error: action.payload.error,
      }
    case SET_TIME_SCHEDULES:
      return {
        ...state,
        loading: true,
      }
    case SET_TIME_SCHEDULES_SUCCESS:
      userIndex = state.list.findIndex(
        findUser => findUser.id === action.payload.userId,
      )
      const user = state.list[userIndex]
      user.schemaWeeks = action.payload.timeSchedules

      return {
        ...state,
        loading: false,
        list: state.list
          .slice(0, userIndex)
          .concat([user])
          .concat(state.list.slice(userIndex + 1)),
      }
    case SET_TIME_SCHEDULES_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}

export const currentUserSelector = (state: RootState): IUser => {
  if (!state.users.currentUser) {
    throw new Error('There is no current user')
  }
  return state.users.currentUser
}
